import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  Platform,
  View,
  Text,
  TouchableOpacity,
  ActivityIndicator,
  Modal,
  Animated,
  useAnimatedValue,
} from 'react-native';
import {
  Button,
  // ButtonGroup,
} from 'react-native-elements';
import { matchPath } from 'react-router-dom';
import Svg, { Line, Text as SvgText } from 'react-native-svg';
import { ArcherContainer, ArcherElement } from 'react-archer';
import { ifIphoneX } from 'react-native-iphone-x-helper';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'ramda';
import { TagCloud } from 'react-tagcloud/rn';

import { AppSyncClientUnauthenticated } from '../../backends/AppSyncClient';
import GetApp from '../../q/GetApp';
import App from '../../modules/data/App';
import Publisher from '../../modules/data/Publisher';
import EndpointBadge from '../../components/apps/EndpointBadge';
import EndpointGraph from '../../components/apps/EndpointGraph';
import Endpoint from '../../modules/data/Endpoint';
import AppBadge from '../../components/apps/AppBadge';
import PublisherBadge from '../../components/apps/PublisherBadge';
import ScrollFading from '../../components/effects/ScrollFading';

import AORTypes from '../../types';
import styles from '../../styles';
import { translate, translateLeg, translateTime } from '../../locales/i18n';
import { serializeFetchParameter } from '@apollo/client';
import AppApprove from '../auditor/AppApprove';
// import { fixGoogleMapsWebStyles } from '../../modules/Utils';

// function sleepFor(sleepDuration) {
//   const now = new Date().getTime();
//   while (new Date().getTime() < now + sleepDuration) { /* do nothing */ }
// }

class AppInfo extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'AppInfo';

    this.setModalVisible = this.setModalVisible.bind(this);

    this.state = {
      isModalVisible: false,
      starting: false,
      selectedEndpoint: 1,
      showIcons: false,
    };

    // this.fadeAnim = useAnimatedValue(0);
    this.fadeAnim = new Animated.Value(0);
  }

  componentDidMount() {
    Animated.timing(this.fadeAnim, {
      fromValue: 0,
      toValue: 1,
      duration: 600,
      useNativeDriver: true,
    }).start();
  }

  static getDerivedStateFromProps(nextProps, _prevState) {
    if (nextProps.app) {
      // TODO
    }
    return {};
  }

  setModalVisible() {
    this.setState({ isModalVisible: true });
  }

  render() {
    const {
      direction, app, history,
      getAnalyticsService,
      user,
    } = this.props;
    const {
      isModalVisible, starting,
      selectedEndpoint,
      showIcons,
    } = this.state;

    if (!app || !app.data) {
      // console.error('no app');
      // return (<></>);
      // if (Platform.OS === 'web') {
      //   sleepFor(3000);
      // }

      return (
        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'white',
          }}
        >
          <Text
            style={{
              marginBottom: 20,
            }}
          >
            {translate('view_loading')}
          </Text>
          <ActivityIndicator size="large" color={styles.primaryColor} />
        </View>
      );
    }

    app.postProcess();

    console.log('Create publisher from the app:');
    console.log(app);
    const publisher = Publisher.createFromApp(app);
    console.log('publisher:');
    console.log(publisher);

    // const buttons = [
    //   'Walking',
    //   'Cycling',
    //   'Driving',
    //   'Teleport',
    // ];

    const endpointsOrdered = [];
    console.log('uuids to render:');
    app.pp.endpointIds.forEach((uuid) => {
      console.log(uuid);

      for (let i = 0; i < app.pp.endpoints.length; i += 1) {
        if (app.data.endpoints[i].uuid === uuid) {
          let endpoint = app.data.endpoints[i];
          endpoint = Endpoint.createFromData(endpoint);
          endpoint.postProcess();
          console.log('endpoint:');
          console.log(endpoint);
          endpointsOrdered.push(endpoint);
          break;
        }
      }
    });
    // endpointsOrdered[1] = endpointsOrdered[0];

    const mapRadius = 20;
    if (Platform.OS === 'web') {
      // fixGoogleMapsWebStyles(direction);
    }

    const actions = (
      <>
        <Button
          title={translate('button_cancel')}
          containerStyle={styles.button.secondaryContainer}
          buttonStyle={styles.button.secondary}
          titleStyle={styles.button.secondaryTitle}
          onPress={() => {
            if (isModalVisible) {
              this.setState({ isModalVisible: false });
            } else {
              getAnalyticsService().report.event('cancel', 'appinfo');
              history.push('/ai-agents');
              // history.goBack(); ???
            }
          }}
        />
        <Button
          title={translate('button_new_query')}
          containerStyle={styles.button.primaryContainer}
          buttonStyle={styles.button.primary}
          titleStyle={styles.button.primaryTitle}
          loading={starting}
          onPress={() => {
            // if (app.type === 0 || isModalVisible) {
            getAnalyticsService().report.event('start', 'appinfo');
            this.setState({ starting: true });
            history.push(`/ai-agent/online/${app.data.uuid}/${endpointsOrdered[selectedEndpoint - 1].pp.uuid}`);
            // } else {
            //   this.setState({ isModalVisible: true });
            // }
          }}
        />
      </>
    );

    const tags = [];
    if (app.pp.tags) {
      app.pp.tags.forEach((tag, index) => {
        tags.push({ value: tag, count: 7 - index });
      });
    } else {
      if (app.data.tag1) {
        tags.push({ value: app.data.tag1, count: 7 });
      }
      if (app.data.tag2) {
        tags.push({ value: app.data.tag2, count: 6 });
      }
      if (app.data.tag3) {
        tags.push({ value: app.data.tag3, count: 5 });
      }
      if (app.data.tag4) {
        tags.push({ value: app.data.tag4, count: 4 });
      }
      if (app.data.tag5) {
        tags.push({ value: app.data.tag5, count: 3 });
      }
    }

    // const fadeIn = () => {
    //   // Will change fadeAnim value to 1 in 5 seconds
    //   Animated.timing(this.fadeAnim, {
    //     fromValue: 0,
    //     toValue: 1,
    //     duration: 5000,
    //     useNativeDriver: true,
    //   }).start();
    // };

    return (
      <View
        style={[styles.view.headed, {
          flex: 1,
          marginBottom: 0,
          paddingBottom: 0,
        }]}
      >
        <View style={{
          flex: 1,
          flexDirection: direction,
          width: '100%',
        }}
        >
          <View style={{ flex: 1, backgroundColor: '#f0f0f0' }}>
            <View style={{
              position: 'absolute',
              top: ifIphoneX(88, 0),
              left: 0,
              right: 0,
              bottom: mapRadius,
            }}
            >
              {/* <TagCloud
                style={{
                  flex: 0.6,
                  alignItems: 'center',
                  justifyContent: 'center',
                  alignSelf: 'center',
                }}
                textStyle={{
                  fontFamily: styles.primaryFont300,
                }}
                minSize={12}
                maxSize={35}
                tags={tags}
                // onPress={(tag) => {
                //   console.log(`'${tag.value}' was selected!`);
                // }}
              /> */}
              <View style={{
                flex: 1,
                alignItems: 'center',
                justifyContent: 'center',
                alignSelf: 'center',
                // borderWidth: 1,
                // borderColor: 'red',
                marginRight: direction === 'column' ? 0 : mapRadius,
              }}
              >
                <Animated.View style={{
                  opacity: this.fadeAnim,
                }}
                >
                  {endpointsOrdered.length >= selectedEndpoint && endpointsOrdered[selectedEndpoint - 1] ? (
                    <EndpointGraph
                      endpoint={endpointsOrdered[selectedEndpoint - 1]}
                    />
                  ) : (
                    <Text>{translate('error_no_endpoint')}</Text>
                  )}
                </Animated.View>
                {/* <Svg
                  style={{
                  }}
                  width="100%"
                  height="100%"
                >
                  <defs>
                    <marker
                      id="triangle"
                      viewBox="0 0 10 10"
                      refX="0"
                      refY="5"
                      markerUnits="strokeWidth"
                      markerWidth="10"
                      markerHeight="8"
                      orient="auto"
                      stroke={styles.primaryColor}
                      fill={styles.primaryColor}
                    >
                      <path d="M 0 0 L 10 5 L 0 10 z" />
                    </marker>
                  </defs>
                  <SvgText x="100" y="100" fontSize="12" fontFamily="Arial" fill="black">input1</SvgText>
                  <SvgText x="200" y="100" fontSize="12" fontFamily="Arial" fill="black">input2</SvgText>
                  <SvgText
                    style={{
                      borderWidth: 1,
                      borderColor: styles.primaryColor,
                    }}
                    x="140"
                    y="200"
                    fontSize="12"
                    fontFamily="Arial"
                    fill="black"
                    borderColor={styles.primaryColor}
                    borderWidth={1}
                  >
                    langgraph
                  </SvgText>
                  <SvgText x="150" y="300" fontSize="12" fontFamily="Arial" fill="black">output</SvgText>
                  <path d="M 120 110 C 120 150 160 150 160 175" fill="none" stroke={styles.primaryColor} markerEnd="url(#triangle)" />
                  <path d="M 220 110 C 220 150 180 150 180 175" fill="none" stroke={styles.primaryColor} markerEnd="url(#triangle)" />
                  <path d="M 170 210 C 170 230 170 270 170 275" fill="none" stroke={styles.primaryColor} markerEnd="url(#triangle)" />
                </Svg> */}
              </View>
            </View>
          </View>
          {/* Outer view that is responsible for absolute positioning _ADJACENT_ to the map */}
          <View
            style={direction === 'column' ? {
              flex: 2,
            } : {
              flex: 1,
              maxWidth: 640,
            }}
          // itemScope
          // itemType="http://schema.org/ConsumerDestination"
          >
            {/* Inner view that is responsible to get _ON TOP_ of the map */}
            <View
              style={[{
                position: 'absolute',
                overflow: 'hidden',
                backgroundColor: 'white',
                alignItems: 'center',
              }, direction === 'column' ? {
                top: -mapRadius,
                bottom: 0,
                width: '100%',
                borderTopLeftRadius: mapRadius,
                borderTopRightRadius: mapRadius,
              } : {
                left: -mapRadius,
                right: 0,
                height: '100%',
                borderTopLeftRadius: mapRadius,
                borderBottomLeftRadius: mapRadius,
              }]}
            >
              <ScrollFading
                containerStyle={{
                  maxWidth: 500,
                  width: '100%',
                }}
                style={{
                  flex: 1,
                  paddingVertical: 5,
                  // overflow: 'hidden',
                  scrollbarWidth: 'none',
                }}
              >
                <TouchableOpacity
                  onPress={() => (
                    history.push(`/publisher/${app.data.user}`)
                  )}
                >
                  <PublisherBadge
                    style={{
                      marginHorizontal: 10,
                      paddingHorizontal: 20,
                    }}
                    publisher={publisher}
                  />
                </TouchableOpacity>
                <TouchableOpacity
                  onPress={() => {
                    this.setState({ showIcons: !showIcons });
                  }}
                >
                  <AppBadge
                    key={app.data.uuid}
                    embedded
                    nopromo
                    style={{
                      marginHorizontal: 10,
                      marginBottom: 15,
                    }}
                    data={app.data}
                    reviewsClickable
                    history={history}
                    notags
                    icons={showIcons}
                  />
                </TouchableOpacity>

                {endpointsOrdered.map((endpoint, idx) => (
                  <View
                    key={`${endpoint.uuid}-${idx}`}
                  >
                    <TouchableOpacity onPress={() => {
                      this.setState({
                        selectedEndpoint: idx + 1,
                      }, () => {
                        this.fadeAnim.setValue(0);
                        Animated.timing(this.fadeAnim, {
                          toValue: 1,
                          duration: 600,
                        }).start();
                      });
                    }}
                    >
                      <EndpointBadge
                        idx={idx + 1}
                        endpoint={endpoint}
                        getAnalyticsService={getAnalyticsService}
                        selected={selectedEndpoint === idx + 1}
                      />
                    </TouchableOpacity>
                    {/* {idx !== 0 && (
                      <Svg style={{ position: 'absolute', left: 24, top: -65 }} width="12" height="90" viewBox="0 0 12 90">
                        <Line
                          x1="6"
                          y1="2"
                          x2="6"
                          y2="88"
                          stroke={styles.primaryColor}
                          strokeWidth={3}
                          strokeDasharray={[6, 5]}
                          strokeDashoffset={0}
                          opacity={0.2}
                        />
                      </Svg>
                    )}
                    <View
                      style={{
                        flex: 1,
                        flexDirection: 'row',
                        padding: 0,
                        marginLeft: 42,
                        marginRight: 16, // styles.endpointBadge.panel.marginHorizontal,
                        marginTop: 11,
                        marginBottom: 9,
                        height: 20,
                        minHeight: 20,
                        maxHeight: 20,
                      }}
                    >
                      {idx !== endpointsOrdered.length - 1 && (
                        <Text
                          style={{
                            textAlign: 'left',
                            textAlignVertical: 'center',
                            fontSize: 12,
                            fontFamily: styles.primaryFont300,
                            fontWeight: '300',
                            lineHeight: 15,
                          }}
                          numberOfLines={1}
                          ellipsizeMode="tail"
                        >
                          {app.data.travelType !== 3 && app.pp.legs && app.pp.legs.length > idx && translateLeg(app.pp.legs[idx].duration.value, app.pp.legs[idx].distance.value)}
                        </Text>
                      )}
                      {endpoint.track && (
                        <>
                          <View
                            style={{
                              flex: 1,
                            }}
                          />
                          <View
                            style={{
                              flexDirection: 'row',
                              width: Platform.OS === 'web' ? 46 : 50, // styles.endpointBadge.blockPlay.width,
                            }}
                          >
                            <Text
                              style={{
                                flex: 1,
                                position: 'absolute',
                                top: -15,
                                left: 0,
                                right: 0,
                                textAlign: 'center',
                                textAlignVertical: 'center',
                                fontSize: 12,
                                fontFamily: styles.primaryFont300,
                                fontWeight: '300',
                                lineHeight: 15,
                              }}
                              numberOfLines={1}
                              ellipsizeMode="tail"
                            >
                              {translateTime(endpoint.duration || 0)}
                            </Text>
                          </View>
                        </>
                      )}
                    </View> */}
                  </View>
                ))}
              </ScrollFading>
              {/* <View style={{
                backgroundColor: 'white',
                width: '100%',
                justifyContent: 'center',
                flexDirection: 'row',
              }}
              >
                {app.pp.endpoints && app.pp.endpoints.length > 1 && (
                  <ButtonGroup
                    textStyle={{ fontSize: 14 }}
                    selectedIndex={travelType}
                    buttons={buttons}
                  />
                )}
              </View> */}
              <View style={{
                backgroundColor: 'white',
                width: '100%',
                justifyContent: 'center',
                flexDirection: 'row',
                ...ifIphoneX({
                  paddingBottom: 10,
                }),
              }}
              >
                {actions}
              </View>
            </View>
          </View>
        </View>

        {isModalVisible && (
          <Modal
            style={{
              position: 'absolute',
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              alignSelf: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#fffc',
              borderWidth: 0,
            }}
            transparent
            presentationStyle="overFullScreen"
            visible
          >
            <View
              style={{
                flex: 1,
                position: 'relative',
                alignSelf: 'center',
                alignItems: 'center',
                alignContent: 'center',
                justifyContent: 'center',
              }}
            >
              <View
                style={{
                  position: 'relative',
                  alignSelf: 'center',
                  backgroundColor: 'white',
                  padding: 24,
                  paddingBottom: 12,
                  borderColor: styles.primaryColor,
                  borderWidth: 8,
                }}
              >
                <Text>{translate('app_info_modal')}</Text>

                <View
                  style={{
                    justifyContent: 'center',
                    flexDirection: 'row',
                    paddingTop: 24,
                  }}
                >
                  {actions}
                </View>
              </View>
            </View>
          </Modal>
        )
        }
      </View>
    );
  }
}

AppInfo.defaultProps = {
  // TODO(clairbee): Even though 'app' is always supplied, we need a temporary value before graphql finishes loading
  app: window && window.app_PRELOADED ? App.createFromData(window.app_PRELOADED) : undefined,
  user: null,
};

AppInfo.propTypes = {
  user: AORTypes.AWS.Cognito.User,
  app: PropTypes.instanceOf(App),
  history: ReactRouterPropTypes.history.isRequired,
  direction: PropTypes.string.isRequired,
  getAnalyticsService: PropTypes.func.isRequired,
};

export default compose(
  graphql(GetApp, {
    skip: window && window.app_PRELOADED,
    // props: props => ({
    //   app: props.data.getMyApps,
    // }),
    props: (props) => {
      console.log('graphql props');
      console.log(props);
      if (!props.data.getApps) {
        return {};
      }
      const app = App.createFromData(props.data.getApps);
      if (app && app.data && app.data.endpoints === undefined) {
        app.data.endpoints = [];
      }
      return {
        app,
      };
    },
    options: (props) => {
      const { location } = props;
      let match = matchPath('/ai-agent-review/:uuid', location.pathname);
      if (!match) {
        match = matchPath('/ai-agent/:uuid', location.pathname);
      }
      const uuid = match ? match.params.uuid : undefined;

      return {
        variables: {
          uuid,
        },
        client: AppSyncClientUnauthenticated,
        fetchPolicy: 'cache-and-network',
        // fetchPolicy: 'network-only',
      };
    },
    client: AppSyncClientUnauthenticated,
  })
)(AppInfo);
